import React, { useEffect, useState } from "react";
import axios from "../../utils/axios";
import Sidebar from "./sidebar";

const Inspectors = () => {
  const [inspectors, setInspectors] = useState([]);

  useEffect(() => {
    const fetchInspectors = async () => {
      try {
        const res = await axios.get("/users");
        const inspectorUsers = res.data.filter(
          (user) => user.role === "inspector"
        );
        setInspectors(inspectorUsers);
      } catch (err) {
        console.error("Failed to fetch inspectors:", err);
      }
    };

    fetchInspectors();
  }, []);

  // Rank badge function
  const renderRankBadge = (rank) => {
    switch (rank) {
      case "1":
        return <span className="px-2 py-1 rounded bg-gray-200 text-gray-700 text-xs">Control Group</span>;
      case "2":
        return <span className="px-2 py-1 rounded bg-blue-200 text-blue-700 text-xs">Treatment [AI]</span>;
      case "3":
        return <span className="px-2 py-1 rounded bg-green-200 text-green-700 text-xs">Treatment [Supervisor]</span>;
      case "4":
        return <span className="px-2 py-1 rounded bg-purple-200 text-purple-700 text-xs">Control</span>;
      case "5":
        return <span className="px-2 py-1 rounded bg-green-300 text-green-900 text-xs">Treatment [Supervisor] NEW</span>;
      case "6":
        return <span className="px-2 py-1 rounded bg-yellow-200 text-yellow-800 text-xs">Treatment [Inspector 6]</span>;
      case "7":
        return <span className="px-2 py-1 rounded bg-yellow-300 text-yellow-900 text-xs">Treatment [Inspector 7]</span>;
      case "8":
        return <span className="px-2 py-1 rounded bg-gray-300 text-gray-800 text-xs">Control Group 2</span>;
      default:
        return <span className="px-2 py-1 rounded bg-gray-100 text-gray-600 text-xs">Unknown</span>;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div className="pl-4"> {/* Add left padding equal to sidebar width */}
        <div className="min-h-screen flex flex-col items-center justify-center p-6">
          <div className="w-full max-w-5xl">
            <h1 className="text-3xl font-bold text-teal-700 mb-6 text-center">Inspectors</h1>

            {inspectors.length === 0 ? (
              <p className="text-gray-500 text-center">No inspectors found.</p>
            ) : (
              <div className="bg-white rounded-xl shadow-lg overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead className="bg-teal-600 text-white">
                    <tr>
                      <th className="px-6 py-3 text-left font-medium">Username</th>
                      <th className="px-6 py-3 text-left font-medium">Name</th>
                      <th className="px-6 py-3 text-left font-medium">Rank</th>
                      <th className="px-6 py-3 text-left font-medium">Circle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inspectors.map((user, idx) => (
                      <tr
                        key={user.id}
                        className={`border-b transition hover:bg-teal-50 ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"}`}
                      >
                        <td className="px-6 py-3 font-semibold text-gray-800">{user.username}</td>
                        <td className="px-6 py-3 text-gray-700">{user.name}</td>
                        <td className="px-6 py-3">{renderRankBadge(user.rank)}</td>
                        <td className="px-6 py-3 text-gray-700">{user.circle}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inspectors;